// extracted by mini-css-extract-plugin
module.exports = {"carouselDisabled":"OurLeadership_carouselDisabled__MkqSJ","carouselArrow":"OurLeadership_carouselArrow__YXJAI","carouselButtonGroup":"OurLeadership_carouselButtonGroup__PDHJ8"};